// Auto-submit timing (0.86.0). Pure logic, no DOM: the auto-submit controller
// passes in how to submit, and tests pass in a fake clock.
//
//   const s = createAutoSubmitter({ delay: 300, submit: (value) => didSubmit })
//   s.request(value)   // on change/input: submit now (delay 0) or after the pause
//   s.cancel()         // drop a pending submit (the form was submitted another way)
//   s.submitted(value) // record a submit made elsewhere so it is not repeated
//
// A value equal to the last submitted one is ignored, so focus changes, arrow
// keys and typing back to the same text do not reload the results. `submit`
// returns true when the form really submitted; a refused submit (failed
// validation) is not remembered, so the same value can be tried again.
export function createAutoSubmitter({ delay = 0, submit, schedule = setTimeout, cancel = clearTimeout } = {}) {
  const wait = Number(delay) > 0 ? Number(delay) : 0
  let timer = null
  let last

  const clear = () => {
    if (timer !== null) cancel(timer)
    timer = null
  }

  const send = (value) => {
    clear()
    if (value === last) return
    if (submit(value) === true) last = value
  }

  return {
    request(value) {
      if (wait === 0) return send(value)
      clear()
      timer = schedule(() => {
        timer = null
        send(value)
      }, wait)
    },
    cancel: clear,
    submitted(value) {
      clear()
      last = value
    }
  }
}
